export const RESET_SEARCH = '@search/RESET_SEARCH';
export const SET_SEARCH = '@search/SET_SEARCH';
